import { render, staticRenderFns } from "./AzconLeaderboardCard.vue?vue&type=template&id=74acbf38&scoped=true"
import script from "./AzconLeaderboardCard.vue?vue&type=script&lang=js"
export * from "./AzconLeaderboardCard.vue?vue&type=script&lang=js"
import style0 from "./AzconLeaderboardCard.vue?vue&type=style&index=0&id=74acbf38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74acbf38",
  null
  
)

export default component.exports